module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2020_en-7590c795a6c1f85eeac212887021960e.jpg";